import React from 'react'
import { makeStyles } from '@material-ui/core/styles'
import { Typography } from 'foundations-library/components'
import { TypographyVariantType } from 'foundations-library/types'
import { getSvg } from './utils'

const useStyles = makeStyles(theme => {
    return {
        root: {
            display: 'flex',
            width: '100%',
            maxWidth: '568px',
            flexDirection: 'column',
            alignItems: 'center',
            gap: 0
        },
        contentContainer: {
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            gap: '10px',
            width: '100%'
        },
        buttonContainer: {
            display: 'flex',
            padding: '30px 0 40px 0',
            justifyContent: 'center',
            alignItems: 'flex-start',
            gap: '20px',
            alignSelf: 'stretch'
        }
    }
})

interface MainProps {
    title?: {
        text: string
        variant?: TypographyVariantType
    }
    description?: {
        text: string
        variant?: TypographyVariantType
    }
    svg: {
        name: string
        styles?: React.CSSProperties
    }
    customContent?: React.ReactNode
    buttons?: React.ReactNode[]
    rootStyles?: React.CSSProperties
}

/**
 *
 */
export const Main = ({ title, description, svg, buttons, rootStyles, customContent }: MainProps) => {
    const classes = useStyles()
    const svgPath = getSvg(svg.name)

    return (
        <div className={classes.root} style={rootStyles || {}}>
            <img src={svgPath} alt={svg.name || 'SVG image'} width={'100%'} style={svg.styles || {}} />
            <div className={classes.contentContainer}>

                {title?.text && <Typography variant={title.variant || 'h4'} align="center">{title.text}</Typography>}
                {description?.text && <Typography variant={description.variant || 'body1'} align="center">
                    {description.text}
                </Typography>}

                {customContent && customContent}

                <div className={classes.buttonContainer}>
                    {buttons?.map((button) => button)}
                </div>
            </div>
        </div>
    )
}
